var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMorter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60196 4.31044L6.33369 3.70683C6.15828 3.31217 6.07057 3.11482 5.93941 2.9638C5.77503 2.77454 5.56075 2.6353 5.32104 2.56195C5.12977 2.50342 4.91382 2.50342 4.48192 2.50342C3.85012 2.50342 3.53421 2.50342 3.26903 2.62487C2.95665 2.76793 2.67454 3.07858 2.56214 3.40326C2.46672 3.67888 2.49405 3.96213 2.54871 4.52862C3.13057 10.5585 6.43644 13.8644 12.4663 14.4462C13.0328 14.5009 13.3161 14.5282 13.5917 14.4328C13.9164 14.3204 14.227 14.0383 14.3701 13.7259C14.4915 13.4607 14.4915 13.1448 14.4915 12.513C14.4915 12.0811 14.4915 11.8652 14.433 11.6739C14.3596 11.4342 14.2204 11.2199 14.0311 11.0555C13.8801 10.9244 13.6828 10.8367 13.2881 10.6612L12.6845 10.393C12.2571 10.203 12.0434 10.1081 11.8262 10.0874C11.6184 10.0676 11.4088 10.0968 11.2143 10.1726C11.011 10.2517 10.8314 10.4014 10.472 10.7008C10.1144 10.9989 9.93554 11.1479 9.71701 11.2278C9.52327 11.2985 9.26716 11.3248 9.06316 11.2947C8.83297 11.2607 10.472 12.1366 8.30423 10.9782C7.20758 10.3922 6.60281 9.7874 6.01674 8.69068C5.82837 8.33824 5.73418 8.16195 5.70027 7.93182C5.6702 7.72775 5.69641 7.47164 5.76718 7.27797C5.84701 7.05942 5.99604 6.88059 6.29411 6.5229C6.59354 6.16358 6.74326 5.98392 6.82242 5.78064C6.89817 5.58612 6.92733 5.37655 6.90756 5.16874C6.8869 4.95157 6.79192 4.73786 6.60196 4.31044Z",
    stroke: "#1E1E1E",
    strokeOpacity: 0.4,
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorter);
export default __webpack_public_path__ + "static/media/morter.916b30374d5ff69e4433d8356120a1c0.svg";
export { ForwardRef as ReactComponent };